import { lazy, Suspense, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
/// Components
import Index from "./jsx/index";
import { connect, useDispatch, useSelector } from "react-redux";
import {
	Route,
	Routes,
	useLocation,
	useNavigate,
	useParams,
} from "react-router-dom";
// action
import { checkAutoLogin } from "./services/AuthService";
import { isAuthenticated } from "./store/selectors/AuthSelectors";
/// Style
import "./css/style.css";
import "react-phone-input-2/lib/bootstrap.css";
import http from "./services/HttpService";
import { setLang } from "./store/actions/AuthActions";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";

const Login = lazy(() => {
	return new Promise((resolve) => {
		setTimeout(() => resolve(import("./jsx/pages/Authintication/Login")), 500);
	});
});

function withRouter(Component) {
	function ComponentWithRouterProp(props) {
		let location = useLocation();
		let navigate = useNavigate();
		let params = useParams();

		return <Component {...props} router={{ location, navigate, params }} />;
	}

	return ComponentWithRouterProp;
}

function App(props) {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	http.setInterceptors(navigate);
	const lang = useSelector((state) => state.auth.lang);
	setLang(lang);

	useEffect(() => {
		checkAutoLogin(dispatch, navigate);
	}, []);

	if (props.isAuthenticated) {
		return (
			<div className={`${lang}`}>
				<Suspense
					fallback={
						<div id="preloader">
							<div className="sk-three-bounce">
								<div className="sk-child sk-bounce1"></div>
								<div className="sk-child sk-bounce2"></div>
								<div className="sk-child sk-bounce3"></div>
							</div>
						</div>
					}>
					<ToastContainer />
					<Index />
				</Suspense>
			</div>
		);
	} else {
		return (
			<div className={`${lang} vh-100`}>
				<Suspense
					fallback={
						<div id="preloader">
							<div className="sk-three-bounce">
								<div className="sk-child sk-bounce1"></div>
								<div className="sk-child sk-bounce2"></div>
								<div className="sk-child sk-bounce3"></div>
							</div>
						</div>
					}>
					<Routes>
						<Route path="/login" element={<Login />} />
					</Routes>
				</Suspense>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		isAuthenticated: isAuthenticated(state),
	};
};

export default withRouter(connect(mapStateToProps)(App));
